import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade",
  id: "modal_add_session_booking",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message message-expired" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Session de coaching impossible")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "Toutes les séances de coaching ont été utilisées. Veuillez renouveler votre abonnement pour pouvoir réserver de nouvelles séances.")
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "row"
}
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-12 mb-2" }
const _hoisted_20 = { class: "col-12 col-md-6 mb-2" }
const _hoisted_21 = { class: "form-group mr-b-0em" }
const _hoisted_22 = { class: "col-12 col-md-6 mb-2" }
const _hoisted_23 = { class: "form-group mr-b-0em" }
const _hoisted_24 = { class: "col-12 d-flex flex-column flex-md-row justify-content-end gap-2" }
const _hoisted_25 = {
  type: "submit",
  class: "btn btn-search"
}
const _hoisted_26 = {
  key: 1,
  class: "col-12"
}
const _hoisted_27 = { class: "text-center p-2" }
const _hoisted_28 = { class: "text-center p-3" }
const _hoisted_29 = {
  key: 2,
  class: "text-center mt-5"
}
const _hoisted_30 = {
  key: 3,
  class: "col-12 position-relative mt-3"
}
const _hoisted_31 = { class: "w-100 overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_informations_income = _resolveComponent("informations-income")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_DateField = _resolveComponent("DateField")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_vue_cal = _resolveComponent("vue-cal")!

  return (_ctx.hasPermission('create_member_session_booking'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isRequestBooking)
              ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.add")), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseModal && _ctx.handleCloseModal(...args))),
                type: "button",
                class: "btn-close",
                "aria-label": "btn-close"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_informations_income),
              (_ctx.income && _ctx.income?.remaining_sessions === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("h5", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.choose_slot")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            (_ctx.isRequestTrainer)
                              ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("form", {
                                class: "forms-sample",
                                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchDataReservedSlots && _ctx.fetchDataReservedSlots(...args)), ["prevent"]))
                              }, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_component_SingleSelect, {
                                      modelValue: _ctx.searchByReservedSlots.trainer_id,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchByReservedSlots.trainer_id) = $event)),
                                      TextLabel: _ctx.i18n.t('tables.session.trainer'),
                                      arrayOptions: _ctx.trainersList,
                                      placeholder: _ctx.i18n.t('tables.session.trainer'),
                                      trackby: 'id',
                                      valueProp: 'id',
                                      label: 'name'
                                    }, null, 8, ["modelValue", "TextLabel", "arrayOptions", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                      _createVNode(_component_DateField, {
                                        modelValue: _ctx.searchByReservedSlots.start_date,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchByReservedSlots.start_date) = $event)),
                                        label: _ctx.i18n.t('tables.subscription_member.start_date'),
                                        disabled: false,
                                        fixedDays: 0,
                                        isFixedDays: false
                                      }, null, 8, ["modelValue", "label"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_DateField, {
                                        modelValue: _ctx.searchByReservedSlots.end_date,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchByReservedSlots.end_date) = $event)),
                                        label: _ctx.i18n.t('tables.subscription_member.end_date'),
                                        disabled: false,
                                        fixedDays: 0,
                                        isFixedDays: false
                                      }, null, 8, ["modelValue", "label"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("button", _hoisted_25, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "fa-search",
                                        size: "lg",
                                        class: "link-icon"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.i18n.t("button.search")), 1)
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-cancel",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCloseModal && _ctx.handleCloseModal(...args)))
                                    }, _toDisplayString(_ctx.i18n.t("button.cancel")), 1)
                                  ])
                                ])
                              ], 32)
                            ]),
                            (_ctx.hasSearched)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createElementVNode("h6", _hoisted_27, [
                                    _createTextVNode(_toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.date_range")) + " ", 1),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.searchByReservedSlots.start_date)), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.to")) + " ", 1),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.searchByReservedSlots.end_date)), 1)
                                  ]),
                                  _createElementVNode("h5", _hoisted_28, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.trainer_availability")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.hasSearched)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Veuillez effectuer une recherche "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createVNode(_component_vue_cal, {
                                      class: "vuecal--blue-theme w-100",
                                      "default-view": "week",
                                      "active-view": "week",
                                      "disable-views": ['years', 'year', 'month', 'day'],
                                      "min-date": _ctx.minDate,
                                      "max-date": _ctx.maxDate,
                                      "time-from": 5 * 60,
                                      "time-to": 23 * 60,
                                      events: _ctx.events,
                                      locale: "fr",
                                      "hide-weekends": false,
                                      "on-event-click": _ctx.handleEventClick,
                                      "selected-date": _ctx.viewDate
                                    }, null, 8, ["min-date", "max-date", "events", "on-event-click", "selected-date"])
                                  ])
                                ]))
                          ])
                        ])
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}